import { CmsComponent, Converter } from '@spartacus/core'
import { Injectable, InjectionToken } from '@angular/core'
import { ConvertedComponentData, Image, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'
import { MbColor } from '../../../tailwind/enums/color-enum'
import { GalleryItemColor } from './gallery-item.component'

@Injectable({ providedIn: 'root' })
export class GalleryItemConverter extends CmsConverterService<GalleryItemData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_image_title_text?.value
    const altText = formData.st_image_alternative_text?.value
    const lazyLoad = formData?.st_image_lazy_loading?.value
    return {
      headline: formData.st_headline ?? defaultTextInput,
      text: formData.st_text ?? defaultTextInput,
      backgroundColor: formData.st_background_color?.value?.identifier ?? MbColor.grey,
      textColor: formData.st_text_color?.value?.identifier ?? MbColor.black,
      image: CmsConverterService.mapImage(formData.st_image_reference, lazyLoad, altText, title),
    }
  }
}

export const GALLERY_ITEM_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, GalleryItemData>>('GalleryItemConverter')

export interface GalleryItemData extends ConvertedComponentData {
  headline: TextInput;
  backgroundColor: GalleryItemColor;
  textColor: string;
  text: TextInput;
  image: Image;
}
